
import React, { useState, useRef, useEffect } from 'react';
import { apiCall } from '@/api/apiCall';
import { toast } from 'sonner';
import { useApiQueue } from '@/hooks/useApiQueue';
// import MawgifJeddah from '@/assets/img/MawgifJeddah.png';
import OnStreet from '@/assets/img/TaifContract-onStreet.png';
import Enforcement from '@/assets/img/TaifContract-Enforcement.png';
import { AssetsPanel } from '../../components/shared/AssetsPanel';
import LoadingComponent from '@/components/common/LoadingComponent';
import carParkIcon from '@/assets/img/car-park-1.png';
import { API_CALL_TIME } from '@/constants/constant';


// ═══════════════════════════════════════════════════════════════════════
// HELPERS
// ═══════════════════════════════════════════════════════════════════════
const groupsToFlat = (groups = []) => {
  const result = [];
  groups.forEach(g => {
    result.push({ name: g.group_name || '', isCategory: true, subCount: '', totalCount: String(g.group_total_qty ?? '-') });
    (g.items || []).forEach(item => {
      result.push({ name: item.item_name || '', isCategory: false, subCount: String(item.qty ?? '-'), totalCount: '' });
    });
  });
  return result;
};

const flatToGroups = (flat) => {
  const groups = [];
  let cur = null;
  flat.forEach(a => {
    if (a.isCategory) {
      if (cur) groups.push(cur);
      cur = { group_name: a.name, group_total_qty: a.totalCount || '', items: [] };
    } else if (cur) {
      cur.items.push({ item_name: a.name, qty: a.subCount || '' });
    }
  });
  if (cur) groups.push(cur);
  return groups;
};

// ═══════════════════════════════════════════════════════════════════════
// ASSET GROUPS HELPER
// ═══════════════════════════════════════════════════════════════════════
function makeAssetGroups(o = {}) {
  return [
    { group_name: 'Ticket Dispenser', group_total_qty: o.ticketDispenser ?? '-', items: [{ item_name: 'DIP G100', qty: '-' }, { item_name: 'G100 64 Bit', qty: '-' }, { item_name: 'G100 32 Bit', qty: '-' }] },
    { group_name: 'Ticket Verifier', group_total_qty: o.ticketVerifier ?? '-', items: [{ item_name: 'EV DIP G100', qty: '-' }, { item_name: 'EV G100 64 Bit', qty: '-' }, { item_name: 'EV G100 32 Bit', qty: '-' }] },
    { group_name: "APM's", group_total_qty: o.apms ?? '-', items: [{ item_name: 'APM ETS-70', qty: '-' }, { item_name: 'APM ETS-100', qty: '-' }] },
    { group_name: 'PIN Pad', group_total_qty: o.pinPad ?? '-', items: [{ item_name: 'IUP250', qty: '-' }] },
    { group_name: 'Card Reader', group_total_qty: o.cardReader ?? '-', items: [{ item_name: 'IUR250', qty: '-' }] },
    { group_name: 'B-Contactless', group_total_qty: o.bContactless ?? '-', items: [{ item_name: 'IUC150', qty: '-' }] },
    { group_name: 'RFID Reader', group_total_qty: o.rfidReader ?? '-', items: [] },
    { group_name: 'IP Barrier', group_total_qty: o.ipBarrier ?? '-', items: [] },
    { group_name: 'ANPR CAMERA', group_total_qty: o.anprCamera ?? '-', items: [{ item_name: 'ARH', qty: '-' }, { item_name: 'Luminera', qty: '-' }] },
    { group_name: 'Sliding Gate', group_total_qty: o.slidingGate ?? '-', items: [{ item_name: 'RIGHT', qty: '-' }, { item_name: 'LEFT', qty: '-' }] },
    { group_name: "PND's", group_total_qty: o.pnds ?? '-', items: [{ item_name: 'TPAL- BNA Large', qty: '-' }, { item_name: 'T-PAL TX', qty: o.tpalTx ?? '-' }, { item_name: 'T-PAL V2', qty: o.tpalV2 ?? '-' }] },
    { group_name: 'Pound Cahier Device', group_total_qty: '-', items: [{ item_name: 'CN-50', qty: '-' }] },
    { group_name: 'Driver Device', group_total_qty: '-', items: [{ item_name: 'CN-51', qty: '-' }] },
    { group_name: 'Enf Device', group_total_qty: o.enfDevice ?? '-', items: [{ item_name: 'Oukitel WP2', qty: '-' }, { item_name: 'Doogee V10', qty: '-' }] },
    { group_name: 'Validation', group_total_qty: '-', items: [{ item_name: 'Lenova Tablet', qty: '-' }] },
    { group_name: 'Printer', group_total_qty: o.printer ?? '-', items: [{ item_name: 'PR-3', qty: '-' }, { item_name: 'SEWOO', qty: '-' }, { item_name: 'BIXOLON', qty: '-' }] },
    { group_name: 'Tow Truck', group_total_qty: o.towTruck ?? '-', items: [] },
    { group_name: 'Clamp Vehicle', group_total_qty: o.clampVehicle ?? '-', items: [] },
    { group_name: 'Support Vehicle', group_total_qty: o.supportVehicle ?? '-', items: [] },
  ];
}

// ═══════════════════════════════════════════════════════════════════════
// CONFIG
// ═══════════════════════════════════════════════════════════════════════
const MAWGIF_JEDDAH_PROFILE_CONFIG = {

  modern_city_contract: {
    profileKey: 'mawgif_jeddah_on_street_profile',
    tariffKey: 'mawgif_jeddah_on_street_tariff',
    assetsKey: 'mawgif_jeddah_on_street_assets',
    pageType: 'on_street',

    profileFallback: {
      table_key: 'mawgif_jeddah_on_street_profile',
      title: 'Modern City Contract On Street - Profile',
      data: {
        total_bays: { label: 'Total On-Street Parking Bays', value: '5,949' },
        contract_term: { value: '14 years' },
        contract_period: { start_date: '23.02.2016', end_date: '12.09.2030' },
        rate_per_hour: { value: 'as per below table' },
      },
    },

    tariffFallback: {
      table_key: 'mawgif_jeddah_on_street_tariff',
      title: 'Modern City Contract Tariff excluding Vat 15%',
      data: {
        rows: [
          {
            product: 'Modern City Contract',
            vehicle_type: 'Any',
            tariff: '04 SAR',
            timing: '08:00 AM - 11:00 PM',
            working_days: 'Friday Off',
          },
        ],
      },
    },

    assetsFallback: {
      table_key: 'mawgif_jeddah_on_street_assets',
      title: 'Modern City Contract',
      data: {
        groups: makeAssetGroups({
          ticketDispenser: '-', ticketVerifier: '-',
          apms: '-', pinPad: '-', cardReader: '-', bContactless: '-',
          rfidReader: '-', ipBarrier: '-', anprCamera: '-',
          slidingGate: '-',
          pnds: '102', tpalTx: '67', tpalV2: '35',
          enfDevice: '-', printer: '-',
          towTruck: '-', clampVehicle: '-', supportVehicle: '-',
        }),
      },
    },
  },
};

// ═══════════════════════════════════════════════════════════════════════
// MAIN COMPONENT
// ═══════════════════════════════════════════════════════════════════════
const ModernCity = ({ page, year = '', month = '', monthNumber = '', contract = '' }) => {
  const cfg = MAWGIF_JEDDAH_PROFILE_CONFIG[page?.type];
  if (!cfg) return null;

  const hasFetchedRef = useRef(false);
  const saveRef = useRef(null);
  const [isSaving, setIsSaving] = useState(false);
  
  // 🔥 State for second API (parking bays)
  const [parkingBaysData, setParkingBaysData] = useState(null);
  
  const [profileData, setProfileData] = useState(null);
  const [assetsData, setAssetsData] = useState(null);
  const [tariffData, setTariffData] = useState(null);

  const { enqueue } = useApiQueue();

  // 🔥 Effective total bays - second API se aayega
  const effectiveTotalBays = parkingBaysData?.total_bays ?? profileData?.data?.total_bays?.value ?? '0';

  // Refs for profile inputs
  // 🔥 REMOVED: totalBaysRef (ab readonly hai)
  const contractTermRef = useRef(null);
  const contractStartDateRef = useRef(null);
  const contractEndDateRef = useRef(null);
  const ratePerHourRef = useRef(null);

  // Refs for tariff table
  const tariffRefs = useRef([]);

  // Refs for assets
  const assetSubCountRefs = useRef([]);
  const assetTotalCountRefs = useRef([]);

  // State refs for data
  const profileDataRef = useRef(null);
  const assetsDataRef = useRef(null);
  const tariffDataRef = useRef(null);

  // ── Fetch BOTH APIs ─────────────────────────────────────────────────────────────
  useEffect(() => {
    if (hasFetchedRef.current) return;
    hasFetchedRef.current = true;
    fetchAllData();
  }, [year, month, monthNumber, contract]);

  const fetchAllData = async () => {
    try {
      // 🔥 Second API params
      const secondApiParams = {
        contract: "1930002",
        year: year,
        month: month,
        device_onstreet: "JV",
        type: "on_street"
      };
      
      const [firstApiResponse, secondApiResponse] = await Promise.all([
        enqueue(() => apiCall('GET', '/boardpack/get-tables-data', { year, contract, month: monthNumber })),
        enqueue(() => apiCall('GET', '/boardpack/parking/bays', secondApiParams))
      ]);

      // Process first API response
      if (firstApiResponse?.success) {
        const data = firstApiResponse?.data || [];
        const find = (key, fb) => data.find(t => t.table_key === key) || fb;

        const profile = find(cfg.profileKey, cfg.profileFallback);
        const assets = find(cfg.assetsKey, cfg.assetsFallback);
        const tariff = find(cfg.tariffKey, cfg.tariffFallback);

        setProfileData(profile);
        setAssetsData(assets);
        setTariffData(tariff);

        profileDataRef.current = profile;
        assetsDataRef.current = assets;
        tariffDataRef.current = tariff;
      }

      // 🔥 Process second API response for parking bays
      if (secondApiResponse?.success && secondApiResponse?.data) {
        setParkingBaysData(secondApiResponse.data);
      } else {
        console.warn("Second API failed:", secondApiResponse?.message);
        setParkingBaysData(null);
      }
      
    } catch (err) {
      console.error('Fetch error:', err);
    }
  };

  // ── Auto-save ─────────────────────────────────────────────────────────
  const autoSave = () => {
    if (saveRef.current) clearTimeout(saveRef.current);
    saveRef.current = setTimeout(saveToAPI, API_CALL_TIME);
  };

  const transformAssetsToApiFormat = () => {
    const currentAssets = assetsDataRef.current?.data?.groups || [];
    const groups = [];
    let currentGroup = null;
    let flatIdx = 0;

    currentAssets.forEach((group) => {
      currentGroup = {
        group_name: group.group_name,
        group_total_qty: assetTotalCountRefs.current[flatIdx]?.value || group.group_total_qty || '-',
        items: []
      };
      flatIdx++;

      (group.items || []).forEach((item) => {
        currentGroup.items.push({
          item_name: item.item_name,
          qty: assetSubCountRefs.current[flatIdx]?.value || item.qty || '-'
        });
        flatIdx++;
      });

      groups.push(currentGroup);
    });

    return groups;
  };

  const saveToAPI = async () => {
    try {
      setIsSaving(true);

      // 🔥 totalBays - ab read-only value use karo
      const currentTotalBays = effectiveTotalBays;
      const currentContractTerm = contractTermRef.current?.value || profileDataRef.current?.data?.contract_term?.value || '';
      const currentStartDate = contractStartDateRef.current?.value || profileDataRef.current?.data?.contract_period?.start_date || '';
      const currentEndDate = contractEndDateRef.current?.value || profileDataRef.current?.data?.contract_period?.end_date || '';
      const currentRatePerHour = ratePerHourRef.current?.value || profileDataRef.current?.data?.rate_per_hour?.value || '';

      // Build tariff rows from refs
      const currentTariffRows = (tariffDataRef.current?.data?.rows || []).map((row, rowIdx) => ({
        product: tariffRefs.current[rowIdx]?.product?.value || row.product || '',
        vehicle_type: tariffRefs.current[rowIdx]?.vehicle_type?.value || row.vehicle_type || '',
        tariff: tariffRefs.current[rowIdx]?.tariff?.value || row.tariff || '',
        timing: tariffRefs.current[rowIdx]?.timing?.value || row.timing || '',
        working_days: tariffRefs.current[rowIdx]?.working_days?.value || row.working_days || ''
      }));

      const tables = [
        {
          table_key: profileDataRef.current?.table_key || cfg.profileKey,
          title: profileDataRef.current?.title || cfg.profileFallback.title,
          data: {
            total_bays: { label: 'Total On-Street Parking Bays', value: currentTotalBays },
            contract_term: { value: currentContractTerm },
            contract_period: { start_date: currentStartDate, end_date: currentEndDate },
            rate_per_hour: { value: currentRatePerHour }
          }
        },
        {
          table_key: assetsDataRef.current?.table_key || cfg.assetsKey,
          title: assetsDataRef.current?.title || cfg.assetsFallback.title,
          data: { groups: transformAssetsToApiFormat() }
        },
        {
          table_key: tariffDataRef.current?.table_key || cfg.tariffKey,
          title: tariffDataRef.current?.title || cfg.tariffFallback.title,
          data: { rows: currentTariffRows }
        },
      ];

      const res = await apiCall('POST', '/boardpack/add-tables-data', {
        contract, year, month: monthNumber, created_by: 1, tables,
      });
      if (!res?.success) throw new Error(res?.message);
      // toast.success('Data saved successfully');
    } catch (err) {
      console.error('Save error:', err);
      toast.error('Failed to save changes');
    } finally {
      setIsSaving(false);
    }
  };

  if (!profileData || !assetsData || !tariffData) {
    return <LoadingComponent />;
  }

  const pd = profileData.data;
  const flatAssets = groupsToFlat(assetsData.data.groups);
  const tariffRows = tariffData.data.rows || [];

  // ═══════════════════════════════════════════════════════════════════
  // RENDER
  // ═══════════════════════════════════════════════════════════════════
  return (
    <div className="min-h-screen p-8 bg-white">

      {/* ── Header ── */}
      <div className="flex justify-between items-center mb-3">
        <h1 className="text-xl font-bold flex-1 text-center">{profileData.title}</h1>
      </div>

      <div className="flex flex-row gap-0 !border-2 !border-black p-3">

        {/* ══ LEFT ══ */}
        <div className="flex-1 pr-4">
          <div className="flex flex-col">

            {/* ── Activities ── */}
            <div className="mb-4">
              <p className="text-[16px] font-bold mb-8">Activities:</p>
              <div className="flex mt-4 ">
                {['On Street', 'Enforcement'].map(label => (
                  <div key={label} className="flex flex-col items-center gap-2">
                    <div className="w-44 h-32 rounded-lg flex items-center justify-center">
                      {label === 'On Street'
                        ? <img src={OnStreet} alt="On Street" style={{ height: '150px', objectFit: 'contain' }} />
                        : <img src={Enforcement} alt="Enforcement" style={{ height: '150px', objectFit: 'contain' }} />}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* ── Profile Info ── */}
            <div className="flex flex-col gap-1 mb-4">

              {/* 🔥 READ-ONLY Total Bays */}
              <div className="flex items-center gap-1 leading-none">
                <img src={carParkIcon} alt="car park" style={{ height: '48px', objectFit: 'contain' }} />
                <span className="text-[12px] leading-none">
                  {pd.total_bays?.label}
                  <strong>
                    <input
                      type="text"
                      value={effectiveTotalBays}
                      readOnly
                      disabled
                      className="px-1 font-bold outline-none bg-transparent !border-0 text-[12px] w-20 cursor-default"
                    />
                  </strong>
                </span>
              </div>

              {/* Contract Term - Editable */}
              <div className="flex items-center gap-2 ml-14">
                <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
                <span className="text-[12px] flex items-center flex-wrap gap-1">
                  Contract term{' '}
                  <strong>
                    <input
                      type="text"
                      defaultValue={pd.contract_term?.value || ''}
                      ref={contractTermRef}
                      onChange={autoSave}
                      className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 text-[12px] w-13"
                    />
                  </strong>
                  ; start date{' '}
                  <strong>
                    <input
                      type="text"
                      defaultValue={pd.contract_period?.start_date || ''}
                      ref={contractStartDateRef}
                      onChange={autoSave}
                      className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 text-[12px] w-18"
                    />
                  </strong>
                  {' to '}
                  <strong>
                    <input
                      type="text"
                      defaultValue={pd.contract_period?.end_date || ''}
                      ref={contractEndDateRef}
                      onChange={autoSave}
                      className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 text-[12px] w-24"
                    />
                  </strong>
                </span>
              </div>

              {/* Rate Per Hour - Editable */}
              <div className="flex items-center gap-2 ml-14">
                <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
                <span className="text-[12px]">
                  Rate per Hour{' '}
                  <strong>
                    <input
                      type="text"
                      defaultValue={pd.rate_per_hour?.value || ''}
                      ref={ratePerHourRef}
                      onChange={autoSave}
                      className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 text-[12px] w-48"
                    />
                  </strong>
                </span>
              </div>

              {/* Assets Deployed */}
              <div className="flex items-center gap-2 ml-14">
                <div className="w-3 h-3 rounded-full bg-red-500 flex-shrink-0" />
                <span className="text-[12px]">Assets Deployed</span>
              </div>
            </div>

          </div>

          {/* ── Tariff Table - Editable ── */}
          {tariffData && (
            <div className="mt-2">
              <table className="!border-collapse text-[9px]">
                <thead>
                  <tr>
                    <th colSpan={5} className="!border !border-black px-2 py-1.5 bg-gray-300 text-center font-bold text-[9px]">
                      {tariffData.title}
                    </th>
                  </tr>
                  <tr className="bg-gray-300">
                    {[
                      { label: 'Product', key: 'product', w: '180px' },
                      { label: 'Vehicle Type', key: 'vehicle_type', w: '80px' },
                      { label: 'Tariff', key: 'tariff', w: '60px' },
                      { label: 'Timing', key: 'timing', w: '150px' },
                      { label: 'Working Days', key: 'working_days', w: '90px' },
                    ].map(({ label, key, w }) => (
                      <th key={key} className="!border !border-black px-2 py-0.5 font-bold text-center" style={{ minWidth: w }}>
                        {label}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {tariffRows.map((row, rIdx) => {
                    if (!tariffRefs.current[rIdx]) tariffRefs.current[rIdx] = {};
                    return (
                      <tr key={rIdx} className={rIdx % 2 === 0 ? 'bg-white' : ''}>
                        {[
                          { key: 'product', w: '180px' },
                          { key: 'vehicle_type', w: '80px' },
                          { key: 'tariff', w: '60px' },
                          { key: 'timing', w: '160px' },
                          { key: 'working_days', w: '90px' },
                        ].map(({ key, w }) => (
                          <td key={key} className="!border !border-black px-1 py-1.5">
                            <div className="flex items-center justify-center h-full">
                              <textarea
                                defaultValue={row[key] || ''}
                                ref={(el) => { tariffRefs.current[rIdx][key] = el; }}
                                onChange={autoSave}
                                className="!border-0 bg-transparent outline-none text-[9px] resize-none text-center"
                                style={{ width: w, minHeight: '30px' }}
                                rows={2}
                              />
                            </div>
                          </td>
                        ))}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>

        {/* ══ RIGHT — Assets Panel ══ */}
        <AssetsPanel
          assetsTable={assetsData}
          flatAssets={flatAssets}
          subCountRefs={assetSubCountRefs}
          totalCountRefs={assetTotalCountRefs}
          onSubCount={(index, value) => {
            const updatedFlat = [...flatAssets];
            updatedFlat[index] = { ...updatedFlat[index], subCount: value };
            setAssetsData(prev => ({
              ...prev,
              data: { ...prev.data, groups: flatToGroups(updatedFlat) }
            }));
            assetsDataRef.current = {
              ...assetsDataRef.current,
              data: { ...assetsDataRef.current.data, groups: flatToGroups(updatedFlat) }
            };
            autoSave();
          }}
          onTotalCount={(index, value) => {
            const updatedFlat = [...flatAssets];
            updatedFlat[index] = { ...updatedFlat[index], totalCount: value };
            setAssetsData(prev => ({
              ...prev,
              data: { ...prev.data, groups: flatToGroups(updatedFlat) }
            }));
            assetsDataRef.current = {
              ...assetsDataRef.current,
              data: { ...assetsDataRef.current.data, groups: flatToGroups(updatedFlat) }
            };
            autoSave();
          }}
        />
      </div>
    </div>
  );
};

export default ModernCity;